import { render, staticRenderFns } from "./TheWelcomeSteps.vue?vue&type=template&id=4a80c7de&scoped=true&"
import script from "./TheWelcomeSteps.vue?vue&type=script&lang=ts&"
export * from "./TheWelcomeSteps.vue?vue&type=script&lang=ts&"
import style0 from "./TheWelcomeSteps.vue?vue&type=style&index=0&id=4a80c7de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a80c7de",
  null
  
)

export default component.exports